import * as React from 'react';
import type { SVGProps } from 'react';
const SvgFunction = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"
    viewBox="0 0 20 20"
    {...props}
  >
    <path d="M10.049 5.26c-.915.92-1.154 2.887-1.385 4.79-.267 2.177-.542 4.429-1.854 5.736-1.016 1.02-2.802 1.049-3 1.049a.81.81 0 0 1 0-1.62c.332 0 1.397-.11 1.858-.57.915-.92 1.154-2.887 1.385-4.79.267-2.178.542-4.43 1.854-5.736 1.458-1.454 4.4-1.09 4.732-1.05a.819.819 0 0 1-.226 1.62c-.631-.097-2.611-.182-3.364.571m4.623 8.336 1.854-1.858a.81.81 0 0 0-1.142-1.142l-1.858 1.854-1.858-1.854a.81.81 0 0 0-1.142 1.142l1.855 1.858-1.855 1.858a.81.81 0 0 0-.045 1.187.81.81 0 0 0 1.187-.046l1.858-1.854 1.858 1.855a.81.81 0 0 0 1.142-1.142z" />
  </svg>
);
export default SvgFunction;
